import { isGeDomain } from 'utils/helpers/domains/getDomain'

import step1 from 'assets/img/promo-page/opening-steps/1.webp'
import step1Mobile from 'assets/img/promo-page/opening-steps/1-mobile.webp'
import step1Tablet from 'assets/img/promo-page/opening-steps/1-tablet.webp'
import step2 from 'assets/img/promo-page/opening-steps/2.webp'
import step2Mobile from 'assets/img/promo-page/opening-steps/2-mobile.webp'
import step2Tablet from 'assets/img/promo-page/opening-steps/2-tablet.webp'
import step3 from 'assets/img/promo-page/opening-steps/3.webp'
import step3Mobile from 'assets/img/promo-page/opening-steps/3-mobile.webp'
import step3Tablet from 'assets/img/promo-page/opening-steps/3-tablet.webp'
import step4 from 'assets/img/promo-page/opening-steps/4.webp'
import step4Mobile from 'assets/img/promo-page/opening-steps/4-mobile.webp'
import step4Tablet from 'assets/img/promo-page/opening-steps/4-tablet.webp'
import step5 from 'assets/img/promo-page/opening-steps/5.webp'
import step5Mobile from 'assets/img/promo-page/opening-steps/5-mobile.webp'
import step5Tablet from 'assets/img/promo-page/opening-steps/5-tablet.webp'

export const stepsData = [
  {
    desktopImage: step1,
    mobileImage: step1Mobile,
    tabletImage: step1Tablet,
    title: isGeDomain() ? 'Откройте юридическое лицо' : 'Откройте ИП или ООО',
    caption: isGeDomain() ? null : 'Через банк',
  },
  {
    desktopImage: step2,
    mobileImage: step2Mobile,
    tabletImage: step2Tablet,
    title: 'Найдите помещение',
    caption: 'На тепловой карте',
  },
  {
    desktopImage: step3,
    mobileImage: step3Mobile,
    tabletImage: step3Tablet,
    title: 'Подайте заявку на сайте',
    caption: 'Рассмотрим за 2 дня',
  },
  {
    desktopImage: step4,
    mobileImage: step4Mobile,
    tabletImage: step4Tablet,
    title: 'Сделайте ремонт',
    caption: 'Требования есть в гайде',
  },
  {
    desktopImage: step5,
    mobileImage: step5Mobile,
    tabletImage: step5Tablet,
    title: 'Активируйте пункт выдачи',
    caption: 'Через заявку на сайте',
  },
]
